import {
    Checkbox,
    Typography,
    TextField,
    makeStyles,
    FormControlLabel,
  } from "@material-ui/core";
  import { Autocomplete } from "@material-ui/lab";
  import { classes as workerStyles } from "../AddWorkerStyles";
  import React, { useEffect, useState } from "react";
  import { getLocationForCountry } from "services/bulkUpload";
  import { Controller, useFormContext } from "react-hook-form";
  import { isEmptyObject } from "utils";
  import { useTranslation } from "react-i18next";
  import { properCase } from "utils";
  
  const useStyles = makeStyles((theme) => workerStyles(theme));
  
  const SecurebaseUserAccess = ({
    selectedWorker,
    manager,
    initialValue,
    setSecurebaseValid,
    setIsSecurebaseWorker,
    setSecurebaseDistBuilingMap,
    securebaseDistBuilingMap,
  }) => {
    const classes = useStyles();
    const { control, setValue, getValues, errors, clearErrors } =
      useFormContext();
    const [districts, setDistricts] = useState([]);
    const [buildings, setBuildings] = useState([]);
    const [isActiveTicked, setIsActiveTicked] = useState(false);
    const [sbDistrict, setSecurebaseDistrict] = useState([]);
    const [sbBuilding, setSecurebaseBuilding] = useState([]);
    const [securebaseRole, setSecurebaseRole] = useState(null);
    const { t, i18n } = useTranslation();

  useEffect(() => {
    if (!isEmptyObject(initialValue) && districts.length>0) {
      setValue("isSecurebaseActive", initialValue.isActive);
    
      if(initialValue.sbDistricts && initialValue.sbDistricts.length>0){
        let districtData=[];
        districts.forEach((record)=>{
            if(initialValue.sbDistricts.includes(record.district)){
              districtData.push(record);
            }
        });
        setValue('sbDistrict', districtData);
      } 
      if(initialValue.sbBuildings && initialValue.sbBuildings.length>0){
       setValue("sbBuilding", initialValue.sbBuildings.map((item) => item.buildingID));
        if(initialValue.sbDistricts && 
          initialValue.sbDistricts.length>0){
            let activatedBuildings =[];
            getValues('sbDistrict').forEach((record)=>{
              const buildingsData = record.buildings;
              let buildingIds = Object.keys(buildingsData).filter(
                (e) => buildingsData[e].sbEnabled === true
              );
              activatedBuildings.push(...buildingIds)
             
        
          });
           setBuildings(activatedBuildings);
        }
      }else if(getValues('sbDistrict').length>0){
            let activatedBuildings =[];
            getValues('sbDistrict').forEach((record)=>{
              const buildingsData = record.buildings;
              let buildingIds = Object.keys(buildingsData).filter(
                (e) => buildingsData[e].sbEnabled === true
              );
              activatedBuildings.push(...buildingIds)
          });
           setBuildings(activatedBuildings);
      }else{
        setValue("sbBuilding", []);
      }
      setValue("securebaseRole", initialValue.role);
      setIsActiveTicked(initialValue?.isActive);
      setSecurebaseDistrict(initialValue?.sbDistricts);
      setSecurebaseBuilding(initialValue?.sbBuildings)
      setSecurebaseRole(initialValue?.role);
    }
  }, [initialValue, districts]);

  useEffect(() => {
    selectedWorker
      ? getLocationForCountry(
          //selectedWorker.worker?.countryCode,
          //selectedWorker.worker?.alternateCountryCode
        )
          .then((data) => {
            let districtBuildingObj={};
            data.forEach((record)=>{
              let DistSecurebaseEnabled = false;
              let buildingIdMap ={};
              Object.entries(record.buildings).map((buildingDet)=>{
                if(buildingDet[1].sbEnabled ===true){
                  DistSecurebaseEnabled =true;
                  buildingIdMap[buildingDet[0]]={
                    buildingID:buildingDet[0],
                    districtID:record.district,
                    branchId:buildingDet[1].sbBranchId?buildingDet[1].sbBranchId:'',
                    sbRegion:buildingDet[1].sbRegion?buildingDet[1].sbRegion:'',
                    
                  };
                }
              });
              if(buildingIdMap && Object.keys(buildingIdMap).length>0){
                districtBuildingObj[record.district] =buildingIdMap; 
              }
              record.DistSecurebaseEnabled = DistSecurebaseEnabled;
            });
           const  filteredDistricts = data.filter((record)=> record.DistSecurebaseEnabled === true);
             setSecurebaseDistBuilingMap(districtBuildingObj);
              setDistricts([...filteredDistricts]);
            
          })
          .catch((err) => {
            console.log("Get districts in Securebase User access ", err);
          })
      : getLocationForCountry(
         // manager?.countryCode,
         // manager?.alternateCountryCode
        )
          .then((data) => {
            let districtBuildingObj={};
            data.forEach((record)=>{
              let DistSecurebaseEnabled = false;
              let buildingIdMap ={};
              Object.entries(record.buildings).map((buildingDet)=>{
                
                if(buildingDet[1].sbEnabled === true){
                  DistSecurebaseEnabled = true;
                  buildingIdMap[buildingDet[0]]={
                    buildingID:buildingDet[0],
                    districtID:record.district,
                    branchId:buildingDet[1].sbBranchId?buildingDet[1].sbBranchId:'',
                    sbRegion:buildingDet[1].sbRegion?buildingDet[1].sbRegion:'',
                  };
                }
              });
              if(buildingIdMap && Object.keys(buildingIdMap).length>0){
                districtBuildingObj[record.district] =buildingIdMap; 
              }
              
              record.DistSecurebaseEnabled = DistSecurebaseEnabled;
            });
           const  filteredDistricts = data.filter((record)=> record.DistSecurebaseEnabled === true);
            setSecurebaseDistBuilingMap(districtBuildingObj);
            setDistricts([...filteredDistricts]);
          })
          .catch((err) => {
            console.log("Get districts in Securebase User access ", err);
          });
  }, []);
  
  useEffect(() => {
    if (getValues("isSecurebaseActive") || initialValue?.isActive) {
        setIsSecurebaseWorker(true);
    } else {
        setIsSecurebaseWorker(false);
    }
  }, [isActiveTicked]);

  useEffect(() => {
    
    if (getValues("sbDistrict")?.length === 0 && buildings.length>0){
        setBuildings([]);
    }
    if (getValues("isSecurebaseActive")) {
      if (getValues("sbDistrict")?.length === 0 ||
        getValues("sbBuilding")?.length===0 ) {
        setSecurebaseValid(false);
      } else setSecurebaseValid(true);
    } else {
        setSecurebaseValid(true);
    }
  }, [
    getValues("sbDistrict"),
    getValues("sbBuilding"),
    getValues("isSecurebaseActive"),
    getValues("securebaseRole"),
  ]);
  return (
    <>
      <Typography
        variant="h6"
        gutterBottom
        className={`${classes.employeeId} ${classes.title}`}
      >
         {t("other.lblSecurebaseUserAccess")}
       
      </Typography>

       <FormControlLabel
        control={
          <Controller
            name="isSecurebaseActive"
            control={control}
            defaultValue={isActiveTicked}
            render={(props) => (
              <>
                <Checkbox
                  {...props}
                  checked={props.value}
                  onChange={(e) => {
                    setIsActiveTicked(e.target.checked);
                    props.onChange(e.target.checked);
                  }}
                  color="primary"
                  style={{ paddingLeft: 0 }}
                  inputRef={props.ref}
                />
              </>
            )}
          />
        }
        label={t("other.lblEnableSecurebaseAccess")}
      />

    <Controller
        name="sbDistrict"
        control={control}
        defaultValue={sbDistrict}
        disabled={!isActiveTicked}
        render={(props) => (
          <Autocomplete
            size="small"
            multiple
            style={{ marginTop: 20, marginBottom: 20 }}
            options={districts}
            value={props.value}
            disableClearable
            disableCloseOnSelect
            clearOnBlur
             getOptionLabel={(option) => option.district?option.district:option}
            disabled={!isActiveTicked}
            renderInput={(params) => (
              <TextField
                {...params}
                // {...props}
                style={{ maxWidth: 300 }}
                id="sbDistrict"
                name="sbDistrict"
                label={properCase( props.value.length > 0 ? t( "other.lblDistrict") : t( "general.select1" ))}
                required={getValues("isSecurebaseActive")}
                error={
                  Boolean(errors.sbDistrict)
                }
                 
              />
            )}
            onChange={(e, newValue) => {
                props.onChange(newValue);
                if(!newValue|| newValue.length<=0){
                  setValue('sbBuilding', []);
                }
                let activatedBuildings =[];
                  newValue.forEach((record)=>{
                    const buildingsData = record.buildings;
                    let buildingIds = Object.keys(buildingsData).filter(
                      (e) => buildingsData[e].sbEnabled === true
                    );
                    activatedBuildings.push(...buildingIds)
                  });
                  if(getValues('sbBuilding').length>0){
                    const filteredbuildingIds = getValues('sbBuilding').filter((buildingId)=>{
                      return activatedBuildings.includes(buildingId)
                    });
                    setValue('sbBuilding', filteredbuildingIds);
                  }
                
                setBuildings(activatedBuildings);
                 
            }}
          />
        )}
      />
    <Controller
        name="sbBuilding"
        control={control}
        defaultValue={sbBuilding}
        disabled={!isActiveTicked}
        render={(props) => (
          <Autocomplete
            size="small"
            multiple
            style={{ marginTop: 20, marginBottom: 20 }}
            options={buildings}
            value={props.value}
            disableClearable
            disableCloseOnSelect
            disabled={!isActiveTicked}
            getOptionLabel={(option) => option?.buildingID?option.buildingID:option}
            renderInput={(params) => (
              <TextField
                {...params}
                // {...props}
                style={{ maxWidth: 300 }}
                id="sbBuilding"
                name="sbBuilding"
                label={properCase( props.value.length > 0 ? t( "other.lblBuilding") : t( "general.select2" ))}
                required={getValues("isSecurebaseActive")}
                error={
                  Boolean(errors.sbBuilding)
                }
                
              />
            )}
            onChange={(e, val) => {
              props.onChange(val);
            }}
          />
        )}
      />


    <Controller
        name="securebaseRole"
        control={control}
        defaultValue={securebaseRole}
        disabled={!isActiveTicked}
        //rules={isActiveTicked ? { required: "Role cannot be blank" } : false}
        render={(props) => (
          <Autocomplete
            size="small"
            style={{ marginTop: 20, marginBottom: 20 }}
            options={[ "Supervisor", "Worker"]}
            value={props.value}
            disableClearable
            disabled={!isActiveTicked}
            renderInput={(params) => (
              <TextField
                {...params}
                // {...props}
                style={{ maxWidth: 300 }}
                id="securebaseRole"
                name="securebaseRole"
                label={properCase( props.value ? t( "other.lblRole") : t( "other.lblSelectRole" ))}
                //required={getValues("isSecurebaseActive")}
                //error={Boolean(errors.securebaseRole) && isActiveTicked}
                //helperText={errors.securebaseRole?.message}
              />
            )}
            onChange={(e, val) => {
              props.onChange(val);
            }}
          />
        )}
      />

     </>
  );
};
export default SecurebaseUserAccess;
  